import { service } from '@ember/service';
import DomainSelect from 'volta/components/domain-select';
import JsonApiInfinityModel, { decorateApiQuery } from 'volta/models/jsonapi-infinity-model';
import { inFilter, lkFilter, niFilter } from 'volta/utils/filters-utils';

import type LabelService from 'volta/services/label-service';
import type PartType from 'volta/models/part-type';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export default class PartTypeSelect extends DomainSelect<PartType, {}> {
  @service labelService!: LabelService;

  get infiniteScroll() {
    return false;
  }

  get propertyKey() {
    return 'code';
  }

  get idKey() {
    return 'id';
  }

  async searchPromise({ search, selected, excluded }: Record<string, any>) {
    const query: IJsonApiQuery = {
      sort: 'code'
    };
    const filter: IJsonApiQuery['filter'] = {};

    if (search && search.length) {
      filter['q'] = lkFilter(search);
    }
    if (selected && selected.length) {
      filter['selectedIds'] = inFilter(selected);
    }
    if (excluded && excluded.length) {
      filter['excludedIds'] = niFilter(excluded);
    }

    query.filter = filter;

    const decoratedQuery = this.args.beforeQuery?.(query) ?? query;

    return await this.infinity.model(
      'part-type',
      decorateApiQuery(decoratedQuery),
      JsonApiInfinityModel
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    PartTypeSelect: typeof PartTypeSelect;
    'part-type-select': typeof PartTypeSelect;
  }
}
